const getOAuthStateFromLocalStorage = () => {
  const oAuthState = localStorage.getItem('anova_o_auth_state')

  return oAuthState
}

export default getOAuthStateFromLocalStorage
